import { ScheduleTourApi } from 'services/Api/schedule/ScheduleTourApi';
import { IGetDataByDocumentResponse } from '../../_domain/dto/ReservePlaceSchedule/IGetDataByDocumentResponse';

export const GetDataByDocumentUseCase = async (localId: string, cpf: string): Promise<IGetDataByDocumentResponse> => {

    const scheduleTourApi = ScheduleTourApi();
    const response = await scheduleTourApi.getDataByDocument(localId, cpf.replace(/[^0-9]/g, ""));
    return response;
}
